import { Expose } from "class-transformer";

export class CreateAnswerOptionDto {
  @Expose()
  answer: string;

  @Expose()
  generatesIssue: boolean;

  @Expose()
  questionId: string;
}
